const outbrain = {}

outbrain.domInjection = () => {
    let script = document.createElement('script');
    let node = document.getElementsByTagName('body')[0];
    
    script.type = 'text/javascript';
    script.async = true;
    script.defer = false;
    script.src = 'https://widgets.outbrain.com/outbrain.js';
    node.appendChild(script);
}

export default outbrain